// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-wrapper[data-v-20226524]{position:relative}.input-wrapper i[data-v-20226524]{position:absolute;top:50%;right:0;transform:translateY(-50%);cursor:pointer}.input-wrapper input[data-v-20226524]{padding-right:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
